import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Add global error handler for module loading errors (deployment transitions)
window.addEventListener('error', (event) => {
  // Only catch module/script loading errors
  if (event.message && (
    event.message.includes('Failed to load module script') ||
    event.message.includes('MIME type') ||
    event.message.includes('ChunkLoadError')
  )) {
    console.error('Module loading error detected:', event.message);

    // Check if we're already in a recovery cycle to prevent infinite loops
    if (!sessionStorage.getItem('app_recovery_refresh')) {
      console.warn('Initiating application recovery due to module loading error');
      // Set recovery marker
      sessionStorage.setItem('app_recovery_refresh', Date.now().toString());
      // Force page reload
      window.location.reload();
    }
  }
});

// StrictMode disabled to prevent double-mounting during development (matches duo_hub)
ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
